;(function() {
    window.setCounter = (target, addStep) => {
        let parent = target.closest('.counter')
        let input = parent.querySelector('input')
        let { min, max } = input
        let value = parseInt(input.value) + addStep
        if (min !== '' && parseInt(min) > value) {
            value = parseInt(input.value)
        }
        if (max !== '' && parseInt(max) < value) {
            value = parseInt(input.value)
        }
        input.value = value
        return value
    }
})()
    